import React from 'react';

/**
 * Freshness dot for the auto-refreshing dashboard. Green while up to date (a
 * ring pings out on every refresh), grey while paused, red when offline or the
 * last refresh failed.
 *
 * live: { outcome: 'ok' | 'error' | 'offline' | null (of the last request),
 *         updating: bool, at: Date | null (last success), refreshes: number }
 */
const LiveIndicator = ({ live, active, online, intervalSec }) => {
  const at = live.at ? live.at.toLocaleTimeString() : null;
  const [tone, label, hint] = !online || live.outcome === 'offline'
    ? ['down', 'Offline', 'No connection. Refreshes as soon as it is back.']
    : live.outcome === 'error'
      ? ['down', 'Update failed', `The last refresh failed; retrying every ${intervalSec} s.`]
      : !active
        ? ['paused', 'Paused', 'Refreshes resume when this tab is focused.']
        : ['ok', 'Live', `Refreshes every ${intervalSec} s while this tab is focused.`];
  return (
    <span className={`qa-live qa-live--${tone} ${live.updating ? 'qa-live--updating' : ''}`}
      title={at ? `Updated ${at}. ${hint}` : hint} role="status">
      <span className="qa-live__dot">
        {/* Keyed so the ping replays from the start on every refresh. */}
        {live.refreshes > 0 && <span key={live.refreshes} className="qa-live__ping" />}
      </span>
      {label}
    </span>
  );
};

export default LiveIndicator;
